var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "library_music"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_14469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 43,
    height: 43,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "library_music_2",
    d: "M21.8444 26.3236C22.8459 26.3236 23.6935 25.9768 24.3872 25.2831C25.0809 24.5894 25.4277 23.7418 25.4277 22.7403V12.4727H30.3203V9.71621H24.0495V20.1218C23.7532 19.8002 23.4213 19.559 23.0537 19.3984C22.6862 19.2374 22.283 19.1569 21.8444 19.1569C20.8428 19.1569 19.9952 19.5038 19.3015 20.1975C18.6079 20.8911 18.261 21.7387 18.261 22.7403C18.261 23.7418 18.6079 24.5894 19.3015 25.2831C19.9952 25.9768 20.8428 26.3236 21.8444 26.3236ZM14.5402 30.4583C13.7154 30.4583 13.0268 30.1821 12.4744 29.6297C11.922 29.0773 11.6458 28.3887 11.6458 27.5639V8.26944C11.6458 7.44467 11.922 6.75608 12.4744 6.20365C13.0268 5.65122 13.7154 5.375 14.5402 5.375H33.8346C34.6594 5.375 35.348 5.65122 35.9004 6.20365C36.4529 6.75608 36.7291 7.44467 36.7291 8.26944V27.5639C36.7291 28.3887 36.4529 29.0773 35.9004 29.6297C35.348 30.1821 34.6594 30.4583 33.8346 30.4583H14.5402ZM14.5402 28.6667H33.8346C34.1106 28.6667 34.3633 28.5518 34.593 28.3222C34.8226 28.0926 34.9374 27.8398 34.9374 27.5639V8.26944C34.9374 7.99352 34.8226 7.74075 34.593 7.51111C34.3633 7.28148 34.1106 7.16667 33.8346 7.16667H14.5402C14.2643 7.16667 14.0115 7.28148 13.7819 7.51111C13.5522 7.74075 13.4374 7.99352 13.4374 8.26944V27.5639C13.4374 27.8398 13.5522 28.0926 13.7819 28.3222C14.0115 28.5518 14.2643 28.6667 14.5402 28.6667ZM9.16519 35.8333C8.34043 35.8333 7.65183 35.5571 7.0994 35.0047C6.54697 34.4523 6.27075 33.7638 6.27075 32.9393V11.8528H8.06242V32.9393C8.06242 33.215 8.17723 33.4676 8.40687 33.6972C8.6365 33.9268 8.88927 34.0417 9.16519 34.0417H30.2513V35.8333H9.16519Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPlaylist);
export default __webpack_public_path__ + "static/media/sidebar_playlist.00e92641c922199c7364f675069eb4cd.svg";
export { ForwardRef as ReactComponent };